// ============================================================
//  Logo.jsx — شعار قادر المشترك بين جميع الشاشات
// ============================================================
import React from 'react';

/** أيقونة البوصلة SVG */
export function LogoIcon({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 82 82" fill="none">
      <defs>
        <radialGradient id="qdrLogoBg" cx="40%" cy="35%" r="65%">
          <stop offset="0%" stopColor="#2d2a6e"/>
          <stop offset="100%" stopColor="#0f0e2a"/>
        </radialGradient>
      </defs>
      <rect x="1" y="1" width="80" height="80" rx="22"
        fill="url(#qdrLogoBg)" stroke="#f59e0b" strokeWidth="1.5" strokeOpacity="0.6"/>
      <polygon points="41,10 45,32 41,37 37,32" fill="#f59e0b"/>
      <polygon points="41,72 43.5,52 41,47 38.5,52" fill="rgba(255,255,255,0.2)"/>
      <polygon points="72,41 52,43.5 47,41 52,38.5" fill="rgba(255,255,255,0.2)"/>
      <polygon points="10,41 30,38.5 35,41 30,43.5" fill="rgba(255,255,255,0.2)"/>
      <circle cx="41" cy="41" r="4.5" fill="#0d1117" stroke="#f59e0b" strokeWidth="1.5"/>
      <circle cx="41" cy="41" r="2" fill="#f59e0b"/>
    </svg>
  );
}

/**
 * شعار قادر مع النص — قابل للنقر للعودة للرئيسية
 * onHome: دالة التنقل للرئيسية (اختيارية — إن لم تُمرَّر يكون غير قابل للنقر)
 */
export function QadderLogo({ onHome, size = 34, subtitle = null }) {
  const inner = (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <LogoIcon size={size} />
      <div style={{ lineHeight: 1.2 }}>
        <div style={{
          color: '#FFD700', fontSize: size * 0.53,
          fontWeight: 900, letterSpacing: -0.5,
          fontFamily: 'Tajawal, sans-serif',
        }}>قادر</div>
        {subtitle && (
          <div style={{ color: 'rgba(255,255,255,0.55)', fontSize: 11, fontFamily: 'Tajawal, sans-serif' }}>
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );

  if (!onHome) return inner;

  return (
    <button onClick={onHome} style={{
      background: 'none', border: 'none', cursor: 'pointer',
      padding: 0, display: 'flex', alignItems: 'center',
    }}>
      {inner}
    </button>
  );
}
